import React from 'react';
import { MapPin } from 'lucide-react';

const areas = [
  'Lexington, KY',
  'Nicholasville, KY',
  'Danville, KY',
  'Richmond, KY',
  'Paris, KY',
  'Harrodsburg, KY',
  'Winchester, KY',
  'Georgetown, KY',
  'Midway, KY',
  'Lawrenceburg, KY',
  'Versailles, KY',
  'Frankfort, KY'
];

const ServiceAreasSection = () => {
  return (
    <section className="py-12 lg:py-16 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content Side */}
          <div>
            <span className="text-emerald-400 font-semibold text-sm uppercase tracking-wider">Service Area</span>
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mt-4 mb-6">
              Areas We Serve
            </h2>
            <p className="text-xl text-stone-300 mb-10">
              Providing service within Kentucky and surrounding areas.
            </p>

            {/* Areas Grid */}
            <div className="grid grid-cols-2 gap-4">
              {areas.map((area, index) => (
                <div key={index} className="flex items-center gap-2 text-stone-300" data-testid={`service-area-${index}`}>
                  <MapPin className="w-4 h-4 text-emerald-400" />
                  <span>{area}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Map/Image Side */}
          <div className="relative">
            <img 
              src="/images/assets/team-2.jpg"
              alt="Kentucky home exterior"
              className="rounded-2xl shadow-xl w-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent rounded-2xl"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-white font-heading font-bold text-xl">Serving Central Kentucky</p>
              <p className="text-stone-300">Residential & Commercial</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
